/**
 * Draynix Subscribe UX — portable (not Muse).
 * When a selling plan is selected, set ATC label to "Subscribe".
 * When one-time / no plan, restore the original label.
 * Covers main product-form ATC and sticky-add-to-cart CTA.
 * Filter Plan monthly floor (merch note): $22.39 — display only; pricing stays Shopify.
 */
(function () {
  const SUBSCRIBE_LABEL = 'Subscribe';
  const SELLING_PLAN_SELECTOR = 'input[name="selling_plan"], input[name="selling_plan_id"]';

  /** Main ATC (submit name=add) + sticky bar (type=button, no name=add). */
  const ADD_BUTTON_SELECTOR = [
    'product-form-component button[type="submit"][name="add"]',
    'form[data-type="add-to-cart-form"] button[type="submit"][name="add"]',
    '.product-form-buttons button[type="submit"][name="add"]',
    'sticky-add-to-cart button.sticky-add-to-cart__button',
    'sticky-add-to-cart button[ref="addToCartButton"]'
  ].join(', ');

  function findAddButtons(root) {
    const scope = root || document;
    return Array.from(scope.querySelectorAll(ADD_BUTTON_SELECTOR));
  }

  /**
   * Prefer the label text node inside .add-to-cart-text__content so icons
   * and sticky quantityDisplay stay intact. Horizon nests one extra span
   * on the main ATC; sticky uses a flat first span.
   */
  function getLabelTarget(btn) {
    const content = btn.querySelector('.add-to-cart-text__content');
    if (content) {
      const first = content.querySelector(':scope > span:not([ref="quantityDisplay"])');
      if (first) {
        const inner = first.querySelector(':scope > span');
        return inner || first;
      }
    }
    const explicit = btn.querySelector('[ref="addToCartText"]');
    if (explicit) return explicit;
    return btn;
  }

  function rememberDefault(btn) {
    if (btn.dataset.draynixDefaultLabel) return;
    const target = getLabelTarget(btn);
    btn.dataset.draynixDefaultLabel = (target.textContent || '').trim() || 'Add to cart';
  }

  function setButtonLabel(btn, next) {
    const target = getLabelTarget(btn);
    if ((target.textContent || '').trim() === next) return;
    target.textContent = next;
  }

  function selectedSellingPlanId() {
    const checked = document.querySelector(
      'input[name="selling_plan"]:checked, input[name="selling_plan_id"]:checked'
    );
    if (checked && checked.value) return checked.value;
    // Some widgets use a hidden input updated on change
    const hidden = document.querySelector(
      'form[data-type="add-to-cart-form"] input[type="hidden"][name="selling_plan"], product-form-component input[type="hidden"][name="selling_plan"]'
    );
    if (hidden && hidden.value) return hidden.value;
    return null;
  }

  function syncLabels() {
    const planId = selectedSellingPlanId();
    findAddButtons().forEach((btn) => {
      rememberDefault(btn);
      const next = planId ? SUBSCRIBE_LABEL : btn.dataset.draynixDefaultLabel;
      setButtonLabel(btn, next);
      btn.setAttribute('data-draynix-subscribe', planId ? 'true' : 'false');
    });
  }

  function onChange(e) {
    const t = e.target;
    if (!t || !t.matches) return;
    if (t.matches(SELLING_PLAN_SELECTOR) || t.closest?.('.shopify-app-block')) {
      // Defer so app widgets can update hidden selling_plan first
      requestAnimationFrame(syncLabels);
    }
  }

  function boot() {
    syncLabels();
    document.addEventListener('change', onChange, true);
    document.addEventListener('input', onChange, true);
    // Subscriptions app / sticky morph may rewrite ATC DOM after load
    const mo = new MutationObserver(() => syncLabels());
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked']
    });
    // Keep observer longer so sticky variant morphs still re-sync
    setTimeout(() => mo.disconnect(), 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
